<template>
  <div>
    <protocol-header :protocol="protocol"
                     v-if="protocol"></protocol-header>
    
    <div class="row">
      <div class="col-12">
        <div class="mt-4 mx-auto">
          <form method="GET"
                accept-charset="UTF-8"
                class="card"
                id="frm-invite"
                ref="frm-invite"
                onsubmit="return false">
            
            <input ref="reply" name="reply" type="hidden">
            
            <div class="card-header">
              <h1 class="card-title mb-0">Participación en protocolo</h1>
            </div>
            <div class="card-body">
              <p>Usted ha sido invitado a participar en el protocolo
                <strong>{{ protocol.title }}</strong> el cual será dirigido por<strong>
                  {{ protocol.user.full_name }}</strong>
              </p>
            </div>
            <div class="card-footer d-flex py-2 px-2">
              <button class="btn btn-lg btn-primary mr-2"
                      data-toggle="modal"
                      data-target="#accept-modal"
                      type="button">
                Aceptar participación
              </button>
              <button class="btn btn-lg btn-outline-danger"
                      data-toggle="modal"
                      data-target="#reject-modal"
                      type="button"
                      v-if="!task.invitation || task.invitation.pivot.status.key !== 'aceptado'">
                Rechazar participación
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    
    <portal to="modals">
      <ok-cancel-dialog id="accept-modal"
                        title="Aceptar participación"
                        content="<p>Por favor confirme su participación en el protocolo</p>"
                        :ok-button-text="'Confirmar participación'"
                        @ok-button-pressed="acceptInvitation"
                        ref="accept-modal"></ok-cancel-dialog>
      
      <ok-cancel-dialog id="reject-modal"
                        title="Rechazar participación"
                        content="<p>¿Está seguro de rechazar su participación en el protocolo?</p>"
                        ok-button-text="Rechazar participación"
                        ref="reject-modal"
                        @ok-button-pressed="rejectInvitation"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import OkCancelDialog from '../ui/OkCancelDialog'
  import ProtocolHeader from './ProtocolHeader'
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'ProtocolInvite',
    components: {
      ProtocolHeader,
      OkCancelDialog,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
    },
    methods: {
      ...mapActions({
        sendReply: 'protocols/sendInviteReply',
      }),
      
      async acceptInvitation() {
        // Set loader in button.
        this.$refs['accept-modal'].sending = true
        
        // Send request.
        const response = await this.sendReply({
          protocol: this.protocol.id,
          user: this.user.id,
          reply: 'accept',
        })
  
        const { status, error, message } = response.data.data
  
        if(status === 'error') {
          AlertManager.error(error)
          this.$refs['accept-modal'].sending = false
    
          return
        }
  
        AlertManager.success(message)
        
        this.$refs['accept-modal'].close()
        
        this.$emit('close-task')
      },
      async rejectInvitation() {
        // Set loader in button.
        this.$refs['reject-modal'].sending = true
        
        // Send request.
        const response = await this.sendReply({
          protocol: this.protocol.id,
          user: this.user.id,
          reply: 'reject',
        })
  
        const { status, error, message } = response.data.data
  
        if(status === 'error') {
          AlertManager.error(error)
          this.$refs['reject-modal'].sending = false
    
          return
        }
        
        AlertManager.success(message)
        
        this.$refs['reject-modal'].close()
        
        this.$emit('close-task')
      },
    },
  }
</script>
